import {
	type FetchExternalAddressesParams,
	type PostExternalAddressPayload,
	type PutExternalAddressByExternalAddressIdPayload
} from '@capsicum/common';

import { walletApi } from '.';

export async function fetchExternalAddresses(params?: FetchExternalAddressesParams) {
	return (await walletApi)
		.fetchExternalAddresses({
			...params
		})
		.then(res => res.data);
}

export async function fetchExternalAddressById(externalAddressId: string) {
	return (await walletApi).fetchExternalAddressByExternalAddressId(externalAddressId).then(res => res.data);
}

export async function postExternalAddress(payload: PostExternalAddressPayload) {
	return (await walletApi).postExternalAddress(payload);
}

export async function putExternalAddress(id: string, payload: PutExternalAddressByExternalAddressIdPayload) {
	return (await walletApi).putExternalAddressByExternalAddressId(id, payload);
}
